// extracted by mini-css-extract-plugin
module.exports =  {"vertical-bar-chart":"VerticalBarChart-component-module__vertical-bar-chart___bsLJN"};